import { render, staticRenderFns } from "./EmployeePageClockRecordModal.vue?vue&type=template&id=c24836b6&scoped=true&"
import script from "./EmployeePageClockRecordModal.vue?vue&type=script&lang=js&"
export * from "./EmployeePageClockRecordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24836b6",
  null
  
)

export default component.exports